/* unplugin-vue-components disabled */import { render } from "./ReportEventView.vue?vue&type=template&id=1b078a6b&scoped=true"
import script from "./ReportEventView.vue?vue&type=script&lang=js"
export * from "./ReportEventView.vue?vue&type=script&lang=js"

import "./ReportEventView.vue?vue&type=style&index=0&id=1b078a6b&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b078a6b"]])

export default __exports__